import { api } from '../api';

export async function getWaitingRoom() {
    try {
        const { status, data } = await api.get(`/sala`)
        if (status !== 200) return [];
        if(!Array.isArray(data)) return [];
        return data;
    }
    catch (error) {
        return [];
    }
};

export async function addCostumerServiceInWaitingRoom(customer_service_id) {
    try {
        const { status } = await api.post(`/sala`, { customer_service_id })
        if (status === 200) return {
            status: 'success',
            message: 'Adicionado a sala de espera'
        };
        return null;
    }
    catch (error) {
        const status = error.response ? error.response.status : null;
        if (status === 400) return {
            status: 'warn',
            message: 'Já está adicionado a uma sala de espera'
        };
        if (status === 409) return {
            status: 'warn',
            message: 'Para adicionar a sala de espera, é necessário que a sessão esteja aberta'
        };
        return {
            status: 'error',
            message: 'Erro ao adicionar cliente a sala de espera'
        };
    }
}

export async function removeCostumerServiceInWaitingRoom(id) {
    try {
        const { status } = await api.delete(`/sala?id=${id}`)
        if (status === 200) return {
            status: 'success',
            message: 'Removido da sala de espera'
        };
        return null;
    }
    catch (error) {
        return {
            status: 'error',
            message: 'Erro ao remover da sala de espera'
        };
    }
}

export async function reorderCostumerServiceInWaitingRoom(costumerServiceIDS) {
    const ids = costumerServiceIDS.toString();
    try {
        const { status } = await api.post(`/reorganiza-sala`, { ids })
        if (status === 200) return {
            status: 'success',
            message: 'Reordenado com sucesso'
        };
        return null;
    }
    catch (error) {
        return {
            status: 'error',
            message: 'Erro ao reordenar'
        };
    }
}